import styled from "styled-components";
import { pxToRem } from "styles/utils";

export const ButtonContainer = styled.div<{ $tone?: "default" | "danger" }>`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* Иконка действия не ужимается под нехватку места: в узкой колонке
     кнопка должна остаться кликабельной, а не превратиться в полоску. */
  flex: 0 0 auto;
  width: ${pxToRem(34)};
  padding: ${({ theme }) => pxToRem(theme.radii.sm)};
  border: none;
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
  background: transparent;
  color: inherit;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, transform 0.15s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.inkSurface};
    transform: scale(1.05);
  }

  &:focus-visible {
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(1)};
  }

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
`;

export const Tooltip = styled.div<{ $visible?: boolean }>`
  position: absolute;
  bottom: calc(100% + ${pxToRem(8)});
  left: 50%;
  z-index: 1000;
  visibility: ${({ $visible }) => ($visible ? "visible" : "hidden")};
  opacity: ${({ $visible }) => ($visible ? "1" : "0")};
  min-width: max-content;
  padding: ${pxToRem(7)} ${pxToRem(10)};
  border-radius: ${pxToRem(8)};
  background: ${({ theme }) => theme.colors.ink};
  box-shadow: ${({ theme }) => theme.shadows.md};
  color: ${({ theme }) => theme.colors.white};
  font-family: inherit;
  font-size: ${pxToRem(13)};
  font-weight: 500;
  line-height: 1.25;
  text-align: center;
  transform: translateX(-50%);
  white-space: nowrap;
  pointer-events: none;
  transition: opacity 0.15s ease;

  &::after {
    position: absolute;
    top: 100%;
    left: 50%;
    width: 0;
    height: 0;
    border: ${pxToRem(5)} solid transparent;
    border-top-color: ${({ theme }) => theme.colors.ink};
    content: "";
    transform: translateX(-50%);
  }
`;
